module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_31 (37).3eb2d2c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_31 (37).mp4
// module id = 812
// module chunks = 1